import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import { getToken, removeToken } from '@/utils/storage';
console.log('当前环境：', process.env['VUE_APP_NODE_ENV']);
var service = axios.create({
  timeout: 30 * 1000
});

// Request interceptors
service.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Response interceptors
service.interceptors.response.use(function (response) {
  var res = response.data;
  if (res.code !== 200) {
    _Toast.fail(res.message || 'Error');
    if (res.code === 401) {
      _Dialog.confirm({
        title: '提示',
        message: '令牌已过期，请重新登录!'
      }).then(function () {
        removeToken();
        location.reload();
      });
    }
    return Promise.reject(new Error(res.message || 'Error'));
  } else {
    return res;
  }
}, function (error) {
  _Toast.fail(error.response.data.message || '网络故障，请稍后再试！');
  if (error.response.status === 401) {
    removeToken();
    location.reload();
  }
  return Promise.reject(error);
});

// 默认配置
var defaultConfig = {
  baseUrl: '',
  tokenKey: '',
  responseType: ''
};

/**
 * get request
 * @param url
 * @param params
 * @param config
 * @return {AxiosPromise}
 */
export var getRequest = function getRequest(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultConfig;
  // 设置请求的 baseURL
  service.defaults.baseURL = (config === null || config === void 0 ? void 0 : config.baseUrl) || process.env['VUE_APP_BASE_API'];
  // 构建请求参数
  var options = {
    method: 'get',
    url: url,
    params: params
  };
  if (config !== null && config !== void 0 && config.responseType) {
    options.responseType = config === null || config === void 0 ? void 0 : config.responseType;
  }

  // 设置token
  if (config !== null && config !== void 0 && config.tokenKey) {
    Object.assign(service.defaults.headers, {
      Authorization: getToken(config === null || config === void 0 ? void 0 : config.tokenKey),
      'Content-Type': 'application/json'
    });
  }
  return service(options);
};

/**
 * post request
 * @param url
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var postRequest = function postRequest(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultConfig;
  // 设置请求的 baseURL
  service.defaults.baseURL = (config === null || config === void 0 ? void 0 : config.baseUrl) || process.env['VUE_APP_BASE_API'];
  Object.assign(service.defaults.headers, {
    'Content-Type': 'application/json'
  });
  // 构建请求参数
  var options = {
    method: 'post',
    url: url,
    data: data
  };
  if (config !== null && config !== void 0 && config.responseType) {
    options.responseType = config === null || config === void 0 ? void 0 : config.responseType;
  }
  // 设置token
  if (config !== null && config !== void 0 && config.tokenKey) {
    Object.assign(service.defaults.headers, {
      Authorization: getToken(config === null || config === void 0 ? void 0 : config.tokenKey)
    });
  }
  return service(options);
};

/**
 * multipart request
 * @param url
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var multipartRequest = function multipartRequest(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultConfig;
  // 设置请求的 baseURL
  service.defaults.baseURL = (config === null || config === void 0 ? void 0 : config.baseUrl) || process.env['VUE_APP_BASE_API'];
  Object.assign(service.defaults.headers, {
    'Content-Type': 'application/json'
  });
  // 构建请求参数
  var options = {
    method: 'post',
    url: url,
    data: data
  };
  if (config !== null && config !== void 0 && config.responseType) {
    options.responseType = config === null || config === void 0 ? void 0 : config.responseType;
  }

  // 设置token
  if (config !== null && config !== void 0 && config.tokenKey) {
    Object.assign(service.defaults.headers, {
      Authorization: getToken(config === null || config === void 0 ? void 0 : config.tokenKey)
    });
  }
  return service(options);
};
export default service;